import React, { useState } from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useThemeTokens } from '../../../providers/themeTokenProvider';
import { Button } from '../button/button';
import { Popover } from '../popover/popover';
import { MenuItem } from '../menuItem/menuItem';

export interface PopoverOption {
  label: string,
  onClick: () => void,
}

export interface ButtonPopoverProps {
  options: PopoverOption[],
  buttonLabel: string,
  variant?: 'filled' | 'tonal' | 'outlined' | 'text',
  color?: 'primary' | 'destructive',
}

export const ButtonPopover: React.FC<ButtonPopoverProps> = ({
  options,
  buttonLabel,
  variant = 'tonal',
  color = 'primary',
}) => {
  const { sys } = useThemeTokens();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (opt: PopoverOption) => {
    opt.onClick();
    handleClose();
  };

  return (
    <>
      <Button variant={variant} color={color} label={buttonLabel} trailingIcon={ExpandMore} onClick={handleOpen} />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        sx={{ '& .MuiPaper-root': { minWidth: 140, borderRadius: sys.borderRadius.md, mt: -1 } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.label} value={opt.label} sx={{ px: 2, py: 1 }} onClick={() => handleSelect(opt)}>
            {opt.label}
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};
